(() => {
  let active = null;
  let opener = null;
  let previousOverflow = '';
  const close = () => {
    if (!active) return;
    active.style.display = 'none';
    document.body.style.overflow = previousOverflow;
    active = null;
    opener?.focus();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('a[href="#promoModal"], .promo-see-details');
    if (trigger) {
      const modal = document.getElementById(trigger.matches('.promo-see-details') ? 'promo-modal' : 'promoModal');
      if (!modal) return;
      event.preventDefault();
      close();
      opener = trigger;
      active = modal;
      previousOverflow = document.body.style.overflow;
      modal.style.display = modal.id === 'promoModal' ? 'flex' : 'block';
      document.body.style.overflow = 'hidden';
      modal.querySelector('.promo-close')?.focus();
    } else if (active && (event.target === active || event.target.closest('.promo-close'))) {
      close();
    }
  });
  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...active.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')].filter(el => el.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
